import React from 'react';
import HeroBanner from '../components/homepage/HeroBanner';
import FeaturedCollections from '../components/homepage/FeaturedCollections';
import TestimonialsSection from '../components/homepage/TestimonialsSection';
import ServicesSection from '../components/homepage/ServicesSection';
import TeamSection from '../components/homepage/TeamSection';

function Home() {
  return (
    <div>
      <HeroBanner />
      <ServicesSection />
      <FeaturedCollections />
      {/* <TeamSection /> */}
      <TestimonialsSection />
    </div>
  );
}

export default Home;